

import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { ConvertService, toNumber } from 'src/app/services/convert.service';
import { GENDERS, DISPLAY_STATUS_OBJECT, PACKAGE_ARR, APP_MEMBER_OBJECT } from 'src/app/dummy/status';
import { TrainingStore } from 'src/app/stores/training/training.store';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { ISchool } from 'src/app/interfaces/student';
import { ACADEMIC_YEAR_STATUS, PROGRAM_OPTION, PROGRAM_TERMS, StatusObj, YEAR_LIST } from 'src/app/dummy/app';
import { checkExistDoc, checkExistOnEditStore } from 'src/app/services/fire-validators.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { toJS } from 'mobx';
import { schoolObj, userObj } from 'src/app/services/mapping.service';


@Component({
  selector: 'app-add-year',
  templateUrl: './add-year.component.html',
  styleUrls: ['./add-year.component.scss']
})
export class AddYearComponent implements OnInit {


  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;
  @ViewChild('photoFile', { static: false }) photoFile: ElementRef;

  form: FormGroup;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  TITLE = 'Add New';
  GENDER: any = GENDERS;
  PACKAGES = PACKAGE_ARR;
  name: AbstractControl;
  startDate: AbstractControl;
  endDate: AbstractControl;
  yearStatus: AbstractControl;
  note: AbstractControl;
  memo: AbstractControl;
  startEnroll: AbstractControl;
  endEnroll: AbstractControl;
  endPayment: AbstractControl;
  dropClass: AbstractControl;
  programOption: AbstractControl;
  program_term: AbstractControl;
  academic_year: AbstractControl;
  end_year_date: AbstractControl;
  organization: AbstractControl;

  yearStatusList = ACADEMIC_YEAR_STATUS.filter(m => m.key !== 2);
  academicYearList = YEAR_LIST;
  programOptionList = PROGRAM_OPTION
  programTermList = PROGRAM_TERMS;
  organizationList: any = []
  START_UPLOAD: boolean;
  uploadPercent: any;
  SELECTED_PICTURE_FILE: any;
  imageSrc: string;

  constructor(
    public dialogRef: MatDialogRef<AddYearComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: TrainingStore,
    private snackBar: MatSnackBar,
    private afs: AngularFirestore,

  ) { }

  async ngOnInit() {
    this.buildForm();
    this.organizationList = await this.store.fetchOrganization();
    this.program_term.disable()
  }
  buildForm(): void {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      // name: [null, Validators.compose([Validators.required]), checkExistDoc(this.afs, "academic_year", "name")],
      startDate: [new Date(), Validators.required],
      endDate: [ConvertService.addMonth(3), Validators.required],
      yearStatus: [this.yearStatusList[0], Validators.required],
      programOption: [this.programOptionList[0], Validators.required],
      note: [null],
      memo: [null],

      startEnroll: [new Date(), Validators.required],
      endEnroll: [ConvertService.addMonth(1), Validators.required],
      dropClass: [ConvertService.addMonth(1), Validators.required],

      endPayment: [ConvertService.addDays(15), Validators.required],
      academic_year: [null, Validators.required],
      end_year_date: [ConvertService.addMonth(12), Validators.required],
      organization: [this.organizationList[0], Validators.required],
      program_term: [PROGRAM_TERMS[0], [Validators.required]],
    })
    this.organization = this.form.controls["organization"];
    this.program_term = this.form.controls["program_term"];
    this.programOption = this.form.controls['programOption'];
    this.name = this.form.controls['name'];
    this.startDate = this.form.controls['startDate'];
    this.endDate = this.form.controls['endDate'];
    this.yearStatus = this.form.controls['yearStatus'];
    this.note = this.form.controls['note'];
    this.memo = this.form.controls['memo'];
    this.startEnroll = this.form.controls['startEnroll'];
    this.endEnroll = this.form.controls['endEnroll'];
    this.endPayment = this.form.controls['endPayment'];
    this.dropClass = this.form.controls['dropClass'];
    this.academic_year = this.form.controls['academic_year'];
    this.end_year_date = this.form.controls['end_year_date'];
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o2) return o1.key === o2.key;
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  _selectionChange(event) {
    const { value } = event;
    if (value && value.key === 2) this.program_term.enable()
    else this.program_term.disable()
  }


  // addNewLine(item?: any) {
  //   const dialogRef = this.dialog.open(AddYearStartEndComponent, {
  //     data: null,
  //     panelClass: 'register-test-overlay-panel',
  //     width: '680px',
  //     height: '100vh',
  //     disableClose: true,
  //     role: 'dialog'
  //   });
  //   dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
  //   dialogRef.afterClosed().subscribe(result => { });
  // }

  // delete(item) {
  //   const { programTermItems } = this.store;
  //   this.store.programTermItems = programTermItems.filter(m => m.key !== item.key);
  // }

  create(f: any, isNew) {
    if (this.form.valid) {
      this.form.disable();
      const { name, startDate, endDate, yearStatus, note, memo, startEnroll, endEnroll, endPayment, dropClass, programOption, academic_year, end_year_date, program_term, organization } = f;
      // const { selectedSchool } = this.env
      const key = this.afs.createId();
      // const { programTermItems } = this.store;

      // const { sysOption } = this.env
      const programTermItems = []
      let sysAcademicYear = null
      let yearKey = academic_year.key;

      // if (programOption.key === 1) {
      //   sysAcademicYear = sysOption.YEAR_BASE
      //   let fromDateKey = null;
      //   let toDateKey = null;
      //   PROGRAM_TERMS.forEach(m => {

      //     switch (m.key) {
      //       case 1:
      //         fromDateKey = toNumber(`${yearKey}${sysAcademicYear.term1.fromDateKey}`);
      //         toDateKey = toNumber(`${yearKey}${sysAcademicYear.term1.toDateKey}`);
      //         break;
      //       case 2:
      //         fromDateKey = toNumber(`${yearKey}${sysAcademicYear.term2.fromDateKey}`);
      //         toDateKey = toNumber(`${yearKey}${sysAcademicYear.term2.toDateKey}`);
      //         break;
      //       case 3:
      //         fromDateKey = toNumber(`${yearKey + 1}${sysAcademicYear.term3.fromDateKey}`);
      //         toDateKey = toNumber(`${yearKey + 1}${sysAcademicYear.term3.toDateKey}`);
      //         break;
      //       case 4:
      //         fromDateKey = toNumber(`${yearKey + 1}${sysAcademicYear.term4.fromDateKey}`);
      //         toDateKey = toNumber(`${yearKey + 1}${sysAcademicYear.term4.toDateKey}`);
      //         break;
      //       default:
      //         break;
      //     }

      //     const dataForm = {
      //       key: m.key,
      //       text: m.text,
      //       program_term_start: ConvertService.numberToDate(fromDateKey),
      //       program_term_start_key: fromDateKey,

      //       program_term_end: ConvertService.numberToDate(toDateKey),
      //       program_term_end_key: toDateKey,
      //     }

      //     programTermItems.push(dataForm)
      //   })
      // } else {

      //   sysAcademicYear = sysOption.TERM_BASE
      //   let fromDateKey = null;
      //   let toDateKey = null;
      //   yearKey = yearKey + 1
      //   PROGRAM_TERMS.forEach(m => {
      //     switch (m.key) {
      //       case 1:
      //         fromDateKey = toNumber(`${yearKey}${sysAcademicYear.term1.fromDateKey}`);
      //         toDateKey = toNumber(`${yearKey}${sysAcademicYear.term1.toDateKey}`);
      //         break;
      //       case 2:
      //         fromDateKey = toNumber(`${yearKey}${sysAcademicYear.term2.fromDateKey}`);
      //         toDateKey = toNumber(`${yearKey}${sysAcademicYear.term2.toDateKey}`);
      //         break;
      //       case 3:
      //         fromDateKey = toNumber(`${yearKey}${sysAcademicYear.term3.fromDateKey}`);
      //         toDateKey = toNumber(`${yearKey}${sysAcademicYear.term3.toDateKey}`);
      //         break;
      //       case 4:
      //         fromDateKey = toNumber(`${yearKey}${sysAcademicYear.term4.fromDateKey}`);
      //         toDateKey = toNumber(`${yearKey}${sysAcademicYear.term4.toDateKey}`);
      //         break;
      //       default:
      //         break;
      //     }

      //     const dataForm = {
      //       key: m.key,
      //       text: m.text,
      //       program_term_start: ConvertService.numberToDate(fromDateKey),
      //       program_term_start_key: fromDateKey,

      //       program_term_end: ConvertService.numberToDate(toDateKey),
      //       program_term_end_key: toDateKey,
      //     }

      //     programTermItems.push(dataForm)
      //   })
      // }

      const item = {
        programTermItems: programTermItems,
        key: key,
        code: null,
        name: name,
        yearStatus: yearStatus,
        note: note,
        memo: memo,

        startDate: startDate,
        startDateKey: ConvertService.toDateKey(startDate),
        endDate: endDate,
        endDateKey: ConvertService.toDateKey(endDate),

        startEnroll: startEnroll,
        startEnrollKey: ConvertService.toDateKey(startEnroll),
        endEnroll: endEnroll,
        endEnrollKey: ConvertService.toDateKey(endEnroll),
        dropClass: dropClass,
        dropClassKey: ConvertService.toDateKey(dropClass),

        endPayment: endPayment,
        endPaymentKey: ConvertService.toDateKey(endPayment),

        academic_year,
        end_year_date,
        end_year_date_key: ConvertService.toDateKey(end_year_date),
        termType: programOption,
        program_term: program_term ? program_term : null,

        status: StatusObj.ACTIVE,
        create_date: new Date(),
        create_by: userObj(this.auth.user),
        pageKey: ConvertService.pageKey(),
        schoolKey: organization.key,
        organization: schoolObj(organization),
        organizationKey: organization.key,

      };

      this.store.addNewSub("academic_year", item, (success, error) => {
        if (success) {
          if (!isNew)
            this.dialogRef.close();
          this.snackBar.open('Academic Year has been created.', 'done', { duration: 2500 });
          this.form.enable();
          this.form.reset();
          this.inputEl.nativeElement.focus();

          this.buildForm();
        }
        else {
          alert(error)
        }
      })
    }
  }



}


